import { AxiosProgressEvent } from "axios";
import kebabcase from "lodash.kebabcase";

import { fetcher } from "helpers/fetcher";

import {
  TUploadOrganizationImageReq,
  TUploadOrganizationImageRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const uploadOrganizationImageProduct = async (
  payload: TUploadOrganizationImageReq,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return await fetcher<
    TUploadOrganizationImageRes,
    TUploadOrganizationImageReq["data"]
  >(ENDPOINT.CORPORATION.UPLOAD_ORGANIZATION_IMAGE_PRODUCT, {
    data: payload.data,
    fileFields: ["file"],
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPLOAD_ORGANIZATION_IMAGE_PRODUCT.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
    onUploadProgress: (progressEvent) => {
      if (onUploadProgress) onUploadProgress(progressEvent);
    },
    namingTransformer: kebabcase,
  });
};
